import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
  BooleanField,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const BannerList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });

  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });

  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "banner_id",
        title: "Banner Id",
        type: "number",
        width: 50,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "banner_url",
        title: "Banner URL",
        width: 200,
        render: (_, params) => {
          return (
            <img
              src={params.banner_url}
              style={{ height: "50px", maxWidth: "100px" }}
              alt=""
            />
          );
        },
      },
      {
        dataIndex: "priority",
        title: "Priority",
        type: "number",
        headerAlign: "left",
        align: "center",
        width: 50,
      },
      {
        dataIndex: "target_url",
        title: "Banner Target URL",
        type: "string",
        headerAlign: "left",
        align: "center",
        width: 200,
      },
      {
        dataIndex: "is_enable",
        title: "Is Enable",
        type: "boolean",
        width: 50,
        render: (_, record) => {
          return (
            <BooleanField
              value={record.is_enable === true}
              trueIcon={"True"}
              falseIcon={"False"}
            />
          );
        },
      },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 200,
      },
      {
        dataIndex: "updated_at",
        title: "Updated At",
        width: 200,
      },
      {
        dataIndex: "actions",
        title: "Actions",
        render: (_, params) => {
          return (
            <>
              <EditButton hideText recordItemId={params.banner_id} />
              <DeleteButton hideText recordItemId={params.banner_id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        width: 80,
        fixed: "right",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          {defaultButtons}
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="banner_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
